<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/**
 * Infobulle « Mode développeur » — icône laptop ORANGE qui ouvre les
 * informations internes de l'analyse (métriques d'un groupe, raisonnement
 * IA…). Aide de compréhension pour l'équipe pendant la mise au point : sera
 * retirée de l'UX finale, d'où le marquage visuel appuyé.
 */

withDefaults(
  defineProps<{
    width?: number;
  }>(),
  { width: 260 },
);

const { t } = useTranslation();
</script>

<template>
  <el-popover
    trigger="click"
    :width="width"
    popper-class="dev-info-popper"
    placement="bottom-end"
  >
    <template #reference>
      <button type="button" class="dev-info-trigger" @click.stop>
        <PhosphorIcon name="laptop" :size="15" weight="bold" />
      </button>
    </template>
    <div class="dev-info-content" @click.stop>
      <div class="dev-info-title">
        <PhosphorIcon name="laptop" :size="14" weight="bold" />
        {{ t("canvas:analysis.devInfo.title") }}
      </div>
      <slot />
    </div>
  </el-popover>
</template>

<style lang="scss" scoped>
.dev-info-trigger {
  border: none;
  background: transparent;
  color: var(--bs-orange);
  opacity: 0.7;
  border-radius: 6px;
  width: 24px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
    background: color-mix(in srgb, var(--bs-orange) 12%, transparent);
  }
}

.dev-info-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--bs-orange);
  font-weight: 600;
  font-size: 0.78rem;
  margin-bottom: 6px;
}

.dev-info-content {
  font-size: 0.75rem;
}
</style>

<style lang="scss">
// Popper téléporté en body : style global, marqué développeur (orange).
.dev-info-popper.el-popover {
  border: 1px solid var(--bs-orange);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
}
</style>
